import { RootState } from '../../../store/reducers';
import { SchoolLeadsDetails } from './school-leads-details.dto';

export const selectSchoolSingleLead = (state: RootState): SchoolLeadsDetails => state.commercial.schoolSingleLead.lead;
